"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseZoomGrids = void 0;
const tstl_1 = require("tstl");
/**
 * Zoom Level Matching Grids
 *
 * @param <T>
 *            grid type
 */
class BaseZoomGrids {
    /**
     * Constructor
     *
     * @param zoom
     *            zoom level
     */
    constructor(zoom) {
        /**
         * Grids
         */
        this.grids = new tstl_1.TreeSet();
        this.zoom = zoom;
        this.beginIterator = this.grids.begin();
    }
    /**
     * Get the zoom level
     *
     * @return zoom level
     */
    getZoom() {
        return this.zoom;
    }
    /**
     * Get the grids within the zoom level
     *
     * @return grids
     */
    getGrids() {
        return this.grids;
    }
    /**
     * Get the number of grids
     *
     * @return number of grids
     */
    numGrids() {
        return this.grids.size();
    }
    /**
     * Determine if the zoom level has grids
     *
     * @return true if has grids
     */
    hasGrids() {
        return !this.grids.empty();
    }
    /**
     * Add a grid
     *
     * @param grid
     *            grid
     * @return true if added
     */
    addGrid(grid) {
        const result = this.grids.push(grid) > 0;
        this.reset();
        return result;
    }
    /**
     * Remove the grid
     *
     * @param grid
     *            grid
     * @return true if removed
     */
    removeGrid(grid) {
        const result = this.grids.erase(grid) > 0;
        this.reset();
        return result;
    }
    next() {
        if (!this.beginIterator.equals(this.grids.end())) {
            const result = this.beginIterator.value;
            this.beginIterator = this.beginIterator.next();
            return {
                done: false,
                value: result,
            };
        }
        else {
            return {
                done: true,
                value: undefined,
            };
        }
    }
    reset() {
        this.beginIterator = this.grids.begin();
    }
    [Symbol.iterator]() {
        return this;
    }
}
exports.BaseZoomGrids = BaseZoomGrids;
//# sourceMappingURL=BaseZoomGrids.js.map